import React from 'react';
import Data from "./Data";
import axios from "axios";
import $ from "jquery";
import { useState , useEffect } from 'react';
import { Badge, Text, Col, Tooltip, Row, Switch, Input, Modal, Button, Spacer } from '@nextui-org/react';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import JalaliUtils from "@date-io/jalaali";
import moment from "moment";
import falocale from 'moment/locale/fa';
import jMoment from "moment-jalaali";
import { useSnackbar } from 'notistack';
import { FiEdit, FiMove } from 'react-icons/fi';
import { Alert, Snackbar, TableCell, TableRow } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { classesActions } from '../Store/classesSlice';
import { GrClose } from 'react-icons/gr';

function ClassesPanelListItem(props){
    
    const {indexParent,index} = props;

    const dispatch = useDispatch();
    const d = useSelector((state) => state.classes.items[indexParent]['infos'][index]);
    const items = useSelector((state) => state.classes.items[indexParent]['infos']);
    const [studentname,setStudentname] = useState(d['studentname']);
    const [studentphone,setStudentphone] = useState(d['studentphone']);
    const [studentphone2,setStudentphone2] = useState(d['studentphone2']);
    const [reserve_time,setReserve_time] = useState(d['reserve_time']);
    const [reserved,setReserved] = useState(d['reserved']);
    const [status,setStatus] = useState(reserved==="no"?true:false);
    const [bderror,setBderror] = useState(false);
    const [calenderopen,setCalenderopen] = useState(false);
    const [birthday,setBirthday] = useState(reserve_time);
    const [borndate,setBornDate] = useState(jMoment(reserve_time,'jYYYY-jMM-jDD'));
    const [fields,setFields] = useState({
        name : d['studentname'],
        phone : d['studentphone']
    });
    const [errors,setErrors] = useState({});
    const [movemodal,setMoveModal] = useState(false);
    const [openMoveModal,setOpenMoveModal] = useState(false);
    const [editmodal,setEditModal] = useState(false);
    const [openEditModal,setOpenEditModal] = useState(false);
    const [openMessage,setOpenMessage] = useState(false);
    const [message,setMessage] = useState('');
    const [messageStatus,setMessageStatus] = useState('info');

    useEffect(() => {
        if(openMoveModal==false){
            setTimeout(() => {
                setMoveModal(false);
            }, 500);
        }
    }, [openMoveModal]);
    useEffect(() => {
        if(movemodal==true){
            setOpenMoveModal(true);
        }
    }, [movemodal]);

    useEffect(() => {
        if(openEditModal==false){
            setTimeout(() => {
                setEditModal(false);
            }, 500);
            setOpenMessage(false);
        }
    }, [openEditModal]);
    useEffect(() => {
        if(editmodal==true){
            setOpenEditModal(true);
        }
    }, [editmodal]);

    const {enqueueSnackbar, closeSnackbar} = useSnackbar();

    const handleChange2=(event)=>{
        
        let target = event.target;
        
        $('#waitspinner').modal('show');

        let reservedd = target.checked?"no":"yes";
        let data = new FormData();
        data.append('masterid',d['masterid']);
        data.append('dayid',d['dayid']);
        data.append('time',d['time']);
        data.append('studentname',studentname);
        data.append('studentphone',studentphone);
        data.append('reserved',reservedd);
        data.append('reserve_time',reserve_time);


        axios.post(Data.server+'editClass.php',data)
            .then(response=>{

                $('#waitspinner').modal('hide');

                if (response.data === "ok") {

                    setReserved(reservedd);
                    setStatus(target.checked);

                    enqueueSnackbar("ویرایش با موفقیت انجام شد", {variant:'success'});
                }
                if (response.data.includes("error update")){
                    
                    enqueueSnackbar("خطای داخلی رخ داد", {variant:'error'});

                }

            })
            .catch(error=>{
                $('#waitspinner').modal('hide');
                enqueueSnackbar("خطای داخلی رخ داد", {variant:'error'});
                console.log(error);
            });
    }

    const handleDateChange=(date)=>{

        let borndatee = moment(date).isValid()?date:"";
        let birthdayy = moment(date).isValid()?date.locale("en").format("jYYYY-jMM-jDD"):"";

        $('#waitspinner').modal('show');

        let data = new FormData();
        data.append('masterid',d['masterid']);
        data.append('dayid',d['dayid']);
        data.append('time',d['time']);
        data.append('studentname',studentname);
        data.append('studentphone',studentphone);
        data.append('reserved',reserved);
        data.append('reserve_time',birthdayy);


        axios.post(Data.server+'editClass.php',data)
            .then(response=>{

                $('#waitspinner').modal('hide');

                if (response.data === "ok") {
                    setBderror(!moment(date).isValid());
                    setBornDate(borndatee);
                    setBirthday(birthdayy);
                    
                    enqueueSnackbar("ویرایش با موفقیت انجام شد", {variant:'success'});

                }
                if (response.data.includes("error update")){
                                        
                    enqueueSnackbar("خطای داخلی رخ داد", {variant:'error'});

                }

            })
            .catch(error=>{
                $('#waitspinner').modal('hide');
                                    
                enqueueSnackbar("خطای داخلی رخ داد", {variant:'error'});

                console.log(error);
            });

        let date2 =moment(date).isValid()?date.locale("fa"):"";
    }
    
    const handleMove=(e,classid2,key2)=> {
        $('#waitspinner').modal('show');
        movemodalClose();

        let token = localStorage.getItem('token');

        let data = new FormData();
        data.append('token',token);
        data.append('classid1',d['id']);
        data.append('classid2',classid2);
        axios.post(Data.server+'moveTime.php',data)
            .then(response=>{

                $('#waitspinner').modal('hide');

                if (response.data === "ok") {
                    enqueueSnackbar("ویرایش با موفقیت انجام شد", {variant:'success'});
                    dispatch(classesActions.empty());
                    
                }
                
                if (response.data.includes("update error")){
                    
                    enqueueSnackbar("خطای داخلی رخ داد", {variant:'error'});
                
                }

            })
            .catch(error=>{
                $('#progressTop').addClass('invisible');
                $('#waitspinner').modal('hide');
                enqueueSnackbar("خطای داخلی رخ داد", {variant:'error'});
                console.log(error);
            });
    }

    const movemodalClose=()=>{
        setOpenMoveModal(false);
    }
    const editmodalClose=()=>{
        setOpenEditModal(false);
    }
    
    const handleChange=(event)=>{
        const target = event.target;
        setFields({
            ...fields,
            [target.name] : target.value
        });
        
        if (fields.name === studentname &&
            fields.phone === studentphone){
            errors['no'] = 'لطفا یکی از فیلدها را تغییر دهید!';
        }else {
            errors['no'] = null;
        }
        if (fields.name === ""){
            errors['name'] = 'لطفا نام هنرجو را وارد کنید!';
        }else {
            errors['name'] = null;
        }
        

        if (fields.phone === ""){
            errors['phone'] = 'لطفا شماره تلفن هنرجو را وارد کنید!';
        }else if (!fields.phone.startsWith('09')){
            errors['phone'] = 'لطفا شماره تلفن را با فرمت 09xxxxxxxxx وارد کنید!';
        }else if (fields.phone.length < 11){
            errors['phone'] = 'لطفا شماره تلفن را کامل وارد کنید!';
        }else {
            errors['phone'] = null;
        }
        
        setErrors({
            ...errors
        });
    }
    
    const handleSubmit=(event)=>{


        handleValidation((valid)=>{
            if (valid){
                editmodalClose();
                handleRequest();
            } else {
                
                if (errors['no'] !== null ){
                    showMessage(errors['no'], 'error');
                }
                if (errors['name'] !== null ){
                    showMessage(errors['name'], 'error');
                }
                if (errors['phone'] !== null ){
                    showMessage(errors['phone'], 'error');
                }
            }
        })

    }

    const showMessage = (msg, status) => {
        setMessage(msg);
        setMessageStatus(status);
        setOpenMessage(true);
    }

    const handleValidation=(callback)=>{
        let formIsValid = true;
        console.log("handleValidation");

        if (fields.name === studentname &&
            fields.phone === studentphone){
            formIsValid = false;
            errors['no'] = 'لطفا یکی از فیلدها را تغییر دهید!';
        }else {
            errors['no'] = null;
        }
        if (fields.name === ""){
            formIsValid = false;
            errors['name'] = 'لطفا نام هنرجو را وارد کنید!';
        }else {
            errors['name'] = null;
        }
        

        if (fields.phone === ""){
            formIsValid = false;
            errors['phone'] = 'لطفا شماره تلفن هنرجو را وارد کنید!';
        }else if (!fields.phone.startsWith('09')){
            formIsValid = false;
            errors['phone'] = 'لطفا شماره تلفن را با فرمت 09xxxxxxxxx وارد کنید!';
        }else if (fields.phone.length < 11){
            formIsValid = false;
            errors['phone'] = 'لطفا شماره تلفن را کامل وارد کنید!';
        }else {
            errors['phone'] = null;
        }
        
        setErrors({...errors});
        return callback(formIsValid);
        
    }
    const handleRequest=()=>{
        console.log("handleRequest")

        $('#waitspinner').modal('show');
        $('#progressTop').removeClass('invisible');

        const {name,phone} = fields;
        const oldnamefamily = studentname;
        const oldphone = studentphone;

        let data = new FormData();
        data.append('masterid',d['masterid']);
        data.append('dayid',d['dayid']);
        data.append('time',d['time']);
        data.append('namefamily',name);
        data.append('phone',phone);
        data.append('oldnamefamily',oldnamefamily);
        data.append('oldphone',oldphone);


        axios.post(Data.server+'editClassInfo.php',data)
            .then(response=>{

                $('#waitspinner').modal('hide');
                $('#progressTop').addClass('invisible');
                console.log(response.data);
                if (response.data === "ok") {

                    enqueueSnackbar("ویرایش با موفقیت انجام شد", {variant:'success'});

                    setStudentname(name);
                    setStudentphone(phone);

                }
                if (response.data.includes("error update")){
                    enqueueSnackbar("خطای داخلی رخ داد", {variant:'error'});
                }

            })
            .catch(error=>{
                $('#waitspinner').modal('hide');
                enqueueSnackbar("خطای داخلی رخ داد", {variant:'error'});
                $('#progressTop').addClass('invisible');
                console.log(error);
            });
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpenMessage(false);
    };
    const action = (
        <div className='text-white' style={{alignItems: 'center', margin:'0px', padding:'0px'}}>
            <GrClose className='m-0 p-0' onClick={handleClose} />
        </div>
    );
    return (
        <TableRow
              key={d['id']}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
            <TableCell align='center'>
                <Col>
                    <Row>
                      <Text b size={16} css={{ tt: "capitalize" }}>
                        {d['time']}
                      </Text>
                    </Row>
                    <Row>
                        <Badge variant="flat" color={reserved==="yes"?"default":d['reserve']==="no"?"success":"error"}>
                            {reserved==="yes"?"غیر فعال":d['reserve']==="no"?"آزاد":"رزرو شده"}
                        </Badge>
                    </Row>
                </Col>
            </TableCell>
            <TableCell align='center'>
                <Switch 
                    shadow 
                    color="secondary" 
                    name="status" 
                    onChange={handleChange2.bind(this)}
                    checked={status} />
            </TableCell>
            <TableCell align='center'>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale={falocale}>
                    <KeyboardDatePicker
                        id={"borndate"+d['id']}
                        className="w-100"
						style={{zIndex: '9999'}}
                        name="borndate"
                        inputProps={
                            {
                                readOnly: true
                            }
                        }
                        variant="dialog"
                        labelFunc={date => moment(date).isValid()?date.format("jYYYY-jMM-jDD") : ""}
                        okLabel={"تایید"}
                        cancelLabel={"لغو"}
                        open={calenderopen}
                        inputVariant="outlined"
                        value={borndate}
                        type="borndate"
                        onClick={() => setCalenderopen(true)}
                        onClose={() => setCalenderopen(false)}
                        onChange={(date) => handleDateChange(date)}
                        label="تاریخ آخرین جلسه"
                        error={bderror}
                        helperText="لطفا تاریخ آخرین جلسه را وارد کنید"
                        margin="normal"
                    />
                </MuiPickersUtilsProvider>

            </TableCell>

            <TableCell align='center'>
                <Col>
                    <Row>
                      <Text b size={16} css={{ tt: "capitalize" }} id={'studentname'+d['id']}>
                        {studentname!='null'&&studentname!=null&&studentname!=''?studentname:"خالی"}
                      </Text>
                    </Row>
                    <Row>
                      <Text b size={15} css={{ tt: "capitalize", color: "$accents7" }} id={'studentphone'+d['id']}>
                        {studentphone!='null'&&studentphone!=null&&studentphone!=''?studentphone:""}
                      </Text>
                    </Row>
					<Row>
                      <Text b size={15} css={{ tt: "capitalize", color: "$accents7" }} id={'studentphone'+d['id']}>
                        {studentphone2!='null'&&studentphone2!=null&&studentphone2!=''?studentphone2:""}
                      </Text>
                    </Row>
					
                </Col>
            </TableCell>
            <TableCell align='center'>
              <Row justify="center" align="center">
                <Col css={{ d: "flex" }}>
                  <Tooltip content="ویرایش">
                    <FiEdit style={{cursor:'pointer'}} className='mx-1' size={25} onClick={(e) => setEditModal(true)} />
                  </Tooltip>
                </Col>
                <Col css={{ d: "flex" }}>
                  <Tooltip content="جابجا">
                    <FiMove style={{cursor:'pointer'}} className='mx-1' size={25} onClick={(e) => setMoveModal(true)} />
                  </Tooltip>
                </Col>
              </Row>
              {movemodal?<Modal
                    closeButton
                    aria-labelledby='modal-title'
                    open={openMoveModal}
                    onClose={movemodalClose}
                >

                    <Modal.Header>
                        <Text id='modal-title' size={18}>
                            جابجایی اطلاعات ساعت 
                            <br />
                            <Text b size={18}>
                                {d['time']}
                            </Text>
                        </Text>
                    </Modal.Header>
                    <Modal.Body>
                        {items.map((dd,ii) => dd['id']!==d['id']?
                            <button 
                                key={ii} 
                                onClick={(e) => handleMove(e,dd['id'])}
                                className={['w-100','btn','text-center',dd['reserved']==="yes"?"btn-outline-secondary":dd['reserve']==="no"?"btn-outline-success":"btn-outline-danger"].join(' ')}>
                                {dd['time']+" "}
                                {dd['reserved']==="yes"?"(غیر فعال)":dd['reserve']==="no"?"(آزاد)":"(رزرو شده)"}
                                <br />
                                <div>{dd['studentname']!='null'&&dd['studentname']!=null&&dd['studentname']!=''?dd['studentname']:""}</div>
                                <div>{dd['reserve_time']}</div>
                            </button>:null
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button auto color='error' onPress={movemodalClose}>
                            بستن
                        </Button>
                    </Modal.Footer>
                </Modal>:<div></div>}

                {editmodal?<Modal
                    closeButton
                    aria-labelledby='modal-title'
                    open={openEditModal}
                    onClose={editmodalClose}
                >
                    
                    <Snackbar
                        open={openMessage}
                        autoHideDuration={3000}
                        onClose={handleClose}
                        action={action}>
                            <Alert onClose={handleClose} variant="filled" severity={messageStatus} sx={{ width: '100%' }}>
                                {message}
                            </Alert>
                    </Snackbar>

                    <Modal.Header>
                        <Text id='modal-title' size={18}>
                            ویرایش
                            <br />
                            <Text b size={18} css={{ tt: "capitalize" }} id={'studentname'+d['id']}>
                                {studentname!='null'&&studentname!=null&&studentname!=''?studentname:"خالی"}
                            </Text>
                            <br />
                            <Text b size={17} css={{ tt: "capitalize", color: "$accents7" }} id={'studentphone'+d['id']}>
                                {studentphone!='null'&&studentphone!=null&&studentphone!=''?studentphone:""}
                            </Text>
                        </Text>
                    </Modal.Header>
                    <Modal.Body>
                        <Input
                            clearable
                            bordered
                            fullWidth
                            type="text"
                            name="name"
                            value={fields['name']}
                            status={errors['name'] ?'error':'default'}
                            helperText={errors['name'] ?errors['name']:''}
                            onChange={handleChange}
                            size='lg'
                            placeholder='نام'
                        />
                        <Spacer y={0.1}/>
                        <Input
                            clearable
                            bordered
                            fullWidth
                            onInput={(e) => {
                                e.target.value = e.target.value.toString().slice(0, 11)
                                e.target.value = e.target.value.replace(/\D/g, "")
                            }}
                            type="number"
                            name="phone"
                            value={fields['phone']}
                            
                            status={errors['phone'] ?'error':'default'}
                            helperText={errors['phone'] ?errors['phone']:''}
                            onChange={handleChange}
                            size='lg'
                            placeholder='شماره تلفن'
                        />
                        <Spacer y={0.1}/>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button auto flat color='error' onPress={editmodalClose}>
                            بستن
                        </Button>
                        <Button auto color='secondary' type='submit' onPress={handleSubmit.bind(this)}>
                            ویرایش
                        </Button>
                    </Modal.Footer>
                </Modal>:<div></div>}
            </TableCell>
        </TableRow>
    );
}

export default ClassesPanelListItem;
